import angular from 'angular';

angular
  .module('cxSettings')
  .controller('TaskTemplateRequiredDocumentTypesDialogCtrl', [
    '$filter',
    'flySvc',
    '$element',
    'close',
    'appUrls',
    '$http',
    'enumCacheSvc',
    'taskTemplateId',
    'requiredDocumentTypes',
    taskTemplateRequiredDocumentTypesDialogCtrl,
  ]);

function taskTemplateRequiredDocumentTypesDialogCtrl(
  $filter,
  flySvc,
  $element,
  close,
  appUrls,
  $http,
  enumCacheSvc,
  taskTemplateId,
  requiredDocumentTypes,
) {
  var vm = this;
  vm.taskTemplateId = taskTemplateId;

  vm.hasChanged = false;
  vm.saving = false;
  vm.selectableDocumentTypes = [];

  enumCacheSvc.get('documentType').then(function(data) {
    const unselectableDocumentTypes = [0, 1, 3, 4, 6, 7, 8, 9, 13, 14, 15, 18, 19, 23, 34, -1, 1000];
    vm.selectableDocumentTypes = data
      .filter(x => !unselectableDocumentTypes.some(y => y === x.key))
      .map(x => ({
        id: x.key,
        name: $filter('translateList')(x.key, 'documentType', x.value),
      }));
    vm.documentTypes = requiredDocumentTypes
      ? vm.selectableDocumentTypes.filter(x => requiredDocumentTypes.includes(x.id))
      : [];
    vm.orgSelectedDocumentTypes = angular.copy(vm.documentTypes || []);
    vm.selectableDocumentTypes = $filter('orderBy')(vm.selectableDocumentTypes, 'name');
  });

  vm.loadSelectableDocumentTypes = function(search) {
    if (vm.selectableDocumentTypes !== null) {
      return $filter('filter')(vm.selectableDocumentTypes, search);
    }
  };

  vm.documentTypesChanged = function() {
    vm.hasChanged =
      vm.documentTypes.length !== vm.orgSelectedDocumentTypes.length ||
      JSON.stringify(vm.documentTypes.map(x => x.id).sort()) !==
        JSON.stringify(vm.orgSelectedDocumentTypes.map(x => x.id).sort());
  };

  vm.save = function() {
    if (vm.saving) return;
    if (!vm.hasChanged) return vm.cancel();

    vm.saving = true;
    return $http
      .post(
        `${appUrls.tasks}/api/TaskTemplates/DocumentTypes/${taskTemplateId}`,
        vm.documentTypes.map(x => x.id),
      )
      .then(
        () => {
          vm.saving = false;
          flySvc.changesSaved();
          $element.modal('hide');
          close(
            vm.documentTypes.map(x => x.id),
            500,
          );
        },
        error => {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
